/* eslint-disable */
const mutations = {
  setStatuses(state, { statuses }) {
    state.data = statuses;
  },
};

export default mutations;
